package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun NavigationScope.NavigationButton(
    text: String,
    onClick: () -> Unit,
    variant: CssStyleVariant<NavNavigableElementKind>? = null,
    modifier: Modifier = Modifier,
    suffix: (@Composable () -> Unit)? = null,
    icon: @Composable () -> Unit,
) {
    Box(
        modifier = NavNavigableElementStyle
            .toModifier(variant)
            .onClick { onClick() }
            .then(modifier)
    ) {
        NavigationItemContent(
            icon = icon,
            text = text,
            isCollapsed = isNavigationCollapsed,
            suffix = suffix,
        )
    }
}
